"use strict";

exports.__esModule = true;
var _DebouncedRender = require("./DebouncedRender");
Object.keys(_DebouncedRender).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DebouncedRender[key]) return;
  exports[key] = _DebouncedRender[key];
});